import {
  AccountService,
  CallHistoryService,
  ContactsService,
  MessagesService,
} from "interfaces";
import { SorensonCallService } from "./SorensonCallService";

export class SorensonAccountService implements AccountService {
  contacts?: ContactsService;
  messages?: MessagesService;
  callHistory?: CallHistoryService;
  callService: SorensonCallService;
  hasDialPad?: boolean;
  authToken?: unknown;

  constructor() {
    this.callService = new SorensonCallService();
    console.log("SorensonCallService");
  }
}
